// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"61":"efaa69bd","234":"70cf31f2"}[chunkId] + ".js";
};